import type {Component, Editor} from 'grapesjs';

export const DECIMAL_RADIX = 10;
export const DEFAULT_STEP = 1;
export const DEFAULT_VALUE = 0;

export interface StepButtonsDescriptor {
  property: string;
  labelKey: string;
  unit: string;
  min: number;
  max: number;
  step?: number;
  defaults?: number;
  onValueChange?: (component: Component, editor: Editor, value: number) => void;
}
